function showHotelDetail(index){
	var item = $("#hotelRowId_"+index);
	var _channelid = $("#priceDetailHotelForm input[name=channelId]").val();
	var _providerCode = $("#priceDetailHotelForm input[name=providerCode]").val()
	var _hotelName= $("#priceDetailHotelForm input[name=hotelName]").val()
	var _id = $("#priceDetailHotelForm input[name=id]").val()
	
	$("#priceDetailHotelForm input[name=channelId]").val($(item).attr("channelId"));
	$("#priceDetailHotelForm input[name=providerCode]").val($(item).attr("providerCode"));
	$("#priceDetailHotelForm input[name=urlHotelName]").val($(item).attr("hotelName"));
	$("#priceDetailHotelForm input[name=id]").val($(item).attr("autocompleteId"));
	$("#priceDetailHotelForm").submit();
	
	$("#priceDetailHotelForm input[name=channelId]").val(_channelid);
	$("#priceDetailHotelForm input[name=providerCode]").val(_providerCode);
	$("#priceDetailHotelForm input[name=urlHotelName]").val(_hotelName);
	$("#priceDetailHotelForm input[name=id]").val(_id);
}

if ($('.slider1').length > 0) {
	var slider = tns({
	  container: '.slider1',
	  controlsContainer: '#controls',
	  prevButton: '.prev1',
	  nextButton: '.next1',
	  items: 1,
	  nav: true,
	  navPosition: 'bottom',
	  loop: false,
	  swipeAngle: false,
	  lazyload: true,
	  mouseDrag: true,
	  speed: 400,
	  gutter: 0,
	  responsive: {
	    900: {
	      items: 3,
	  	  gutter: 16,
	    }
	  }
	});
}
if ($('.slider2').length > 0) {
	var slider = tns({
	  container: '.slider2',
	  controlsContainer: '#controls2',
	  prevButton: '.prev2',
	  nextButton: '.next2',
	  items: 1,
	  nav: true,
	  navPosition: 'bottom',
	  loop: false,
	  swipeAngle: false,
	  lazyload: true,
	  mouseDrag: true,
	  speed: 400,
	  gutter: 0,
	  responsive: {
	    900: {
	  	  gutter: 16,
	      items: 3
	    }
	  }
	});
}

var autoCompleteResult="";
var totalAdult = 0;
var totalChild = 0;
var totalRoomCount = 0;

var  hotelSearch = {
	searchAutoCompleteId:null,
	searchUrl:null,
	fromDate:null,
	toDate:null
};

$.extend($.ui.menu.prototype.options, {
    items: "> :not(.ui-autocomplete-category)"
});

$(document).ready(function() {
	$('.loading').modal({
		show : false
	});
	
	$(".sort-h").click(function() {
		$(this).addClass("active");
		$(".sort-v").removeClass("active");
		$(".rows").removeClass("row");
		$(".row-cols").removeClass("col-md-4");
		$(".row1,.row2").removeClass("flex-column");
		$(".row1 > div,.row2 > div").removeClass("col-md-12");
		$(".row1 > div:first-child").addClass("col-md-9");
		$(".row1 > div:last-child").addClass("col-md-3 border-start");
		$(".row1 .price").addClass("text-md-end");
		$(".row1 > div:first-child").addClass("p-4");
		$(".row2 > div:last-child").removeClass("px-4");
		$(".row2 .text-title").removeClass("h6 bold text-center");
		$(".row2 .text-body-2").removeClass("text-center");
	});
	$(".sort-v").click(function() {
		$(this).addClass("active");
		$(".sort-h").removeClass("active");
		$(".rows").addClass("row");
		$(".row-cols").addClass("col-md-4");
		$(".row1 > div,.row2 > div").addClass("col-md-12");
		$(".row1 > div:first-child").removeClass("col-md-9");
		$(".row1 > div:last-child").removeClass("col-md-3 border-start");
		$(".row1 .price").removeClass("text-md-end");
		$(".row1 > div:first-child").removeClass("p-4");
		$(".row2 > div:last-child").addClass("px-4");
		$(".row2 .text-title").addClass("h6 bold text-center");
		$(".row2 .text-body-2").addClass("text-center");
	});
	
    $('.roomSelect').val("1");
    var isHotelDetail = $("[name='hotelDetail']").val();
    if(!isHotelDetail){
        parseCookieSearchValues();
    }

	if(Hotel.source){
		var date = new Date();
		date.setTime(date.getTime() + (30 * 60 * 1000)); //30 minutes
		$.cookie('source', Hotel.source, { expires : date,  path : '/' });
	}
	
	$('.hotelAutoComplete').on('change', function() {
		$('html, body').animate({scrollTop: $("#hotelSearch").offset().top}, 100);
	});

	$('#makeSearch').click(function(event) {
		$("#sumButton").trigger('click');
	});
	
	$('[name="hotelSearchForm"]').validate();
	
	bindDatePicker();
	
	$.widget("custom.catcomplete", $.ui.autocomplete, {
		_renderMenu : function(ul, items) {
			var that = this, currentCategory = "";
			$.each(items, function(index, item) {
				if (item.category != currentCategory) {
					if (item.category == "HOTEL") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconHotel' >" + FmtMessage.getMessage('js.result.hotel') + "</li>");
					} else if (item.category == "CITY") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconCity' >" + FmtMessage.getMessage('js.result.city') + "</li>");
					} else if (item.category == "DISTRICT") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconDistrict' >" + FmtMessage.getMessage('js.result.district') + "</li>");
					} else if (item.category == "CATEGORY") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconHotel' >" + FmtMessage.getMessage('js.result.hotel.category') + "</li>");
					}

					currentCategory = item.category;
				}
				that._renderItemData(ul, item);
			});
		},
        _renderItem: function (ul, item) {
    		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
    		return $("<li class='ui-autocomplete-item'></li>")
    			.data("ui-autocomplete-item", item)
    			.append("<a>" + item.label + "</a>")
    			.appendTo(ul);
    		}
	});
	
	var re = null;
	$(".hotelAutoComplete").catcomplete(
	{   delay: 500,
		source : function(request, response) {
			$.ajax({
				url : "/hotel/hotels",
				dataType : "json",
				data : {
					output : 'json',
					results : 100,
					query : request.term
				},
				success: function(data) {
					if(data == null){
						data = [];
					}
					
					var itemList = $.map(data, function(item) {
						return {
							value: item.name + " ( " + item.hotelCount + " "+ FmtMessage.getMessage('js.title.hotel.name') + " ) ",
							key: item.id,
							category : item.type,
							name : item.name,
							hotelId:item.hotelId
						};
					});
					
					re = new RegExp("(" + $.ui.autocomplete.escapeRegex(request.term) + ")", "gi");
					
					var itemListNew = getHotelItemLabels(itemList);
					response(itemListNew);
				}				
			});
		},
		minLength : 2,
		select: function (a, b) {
			document.activeElement.blur();
			if(b.item.hotelId){
				$('[name="id"]', this.form).val(b.item.hotelId);
			}
			$('[name="id"]', this.form).val(b.item.key);
			$(this).data("autoCompleteResult", b.item.value);
			
			if(!$('[name="urlHotelName"]').length ){
				$('<input>').attr({
				    type: 'hidden',
				    id: 'urlHotelName',
				    name: 'urlHotelName'
				}).appendTo(this.form);
			}
			$('[name="urlHotelName"]').val(b.item.name);
		},
		open: function(event, ui) {
	        $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
	    }
	}).change(function (event) {
		if ($(this).data("autoCompleteResult") != this.value)
			$('[name="id"]', this.form).val("");
	});

	$.ui.autocomplete.prototype._renderItem = function (ul, item) {
		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
		return $("<li></li>")
			.data("ui-autocomplete-item", item)
			.append("<a>" + item.label + "</a>")
			.appendTo(ul);
		};

	bindRoomSelector();

	$(".hotelAutoComplete").click(function() {
		$(this).select();
	});
});

function getHotelItemLabels(itemList){
	var itemListNew = $.map(itemList, function(item) {
		var category = item.category;
		if (category == "HOTEL" || category == "CATEGORY"){
			item.value = item.name;
		}
		return item;
	});
	
	return itemListNew;
}

function bindDatePicker() {
	if ($('#dates').length == 0) {
		return;
	}
	
	$('#dates').daterangepicker({
      minDate: moment(),
      minYear: 2022,
      maxYear: parseInt(moment().format('YYYY'),10),
	  autoApply: true,
      locale: {
        format: 'DD.MM.YYYY'
      },
      startDate: $('input[name="checkInDate"]').val().length > 0 ? moment($('input[name="checkInDate"]').val(),'DD.MM.YYYY') : moment(),
      endDate: $('input[name="checkOutDate"]').val().length > 0 ? moment($('input[name="checkOutDate"]').val(),'DD.MM.YYYY') : moment()
    });
    
    $('#dates').on('apply.daterangepicker', function(ev, picker) {
  		$('input[name="checkInDate"]').val(picker.startDate.format('DD.MM.YYYY'));
  		$('input[name="checkOutDate"]').val(picker.endDate.format('DD.MM.YYYY'));
	});
}

function bindRoomSelector(context) {
	if (context == undefined)
		context = document;
	
	$(".roomSelect", context).on('change', function(event) {
		var roomCount = $(this).val();
		$(".roomSelect").val(roomCount);
		$(".travelerSelectRoom").html(roomCount);
		
		for ( var i = 1; i < 5; i++) {
			if (i <= roomCount) {
				$(".room" + i).addClass('d-flex').show();
			} else {
				$(".room" + i).hide().removeClass('d-flex');
			}
		}
		
		setTotalGuest($(this).closest("form"));
		
		var locale = $.cookie('siteLocale');
		if(locale == "en" && roomCount > 1){
			$(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.rooms'));
		}else{
			$(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.room'));
		}
	}).change();

	$(".childCount", context).on('change', function (event) {
		var childCount =  parseInt(this.value);
		var index = this.name.split('_')[1];
		$("[name="+this.name+"]").val(childCount);

		for ( var i = 1; i < 4; i++) {
			if (i <= childCount) {
				$(".childAge" + index + i).show();
			} else {
				$(".childAge" + index + i).hide();
			}
		}
		
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".adultCount", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".childAge", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
	}).change();
}

function setTotalGuest(form) {
	var roomCount = parseInt(form.find("#glRoomCount").val());
	var totalAdultCount = 0;
	var totalChildCount = 0;
	for ( var i = 1; i <= roomCount; i++) {
		totalAdultCount = totalAdultCount + parseInt(form.find("[name=adultCount_" + i + "]").val());
		totalChildCount = totalChildCount + parseInt(form.find("[name=childCount_" + i + "]").val());
	}
	var totalGuest = totalAdultCount + totalChildCount;
	$(".travelerSelectGuest").html(totalGuest);
	var locale = $.cookie('siteLocale');
	if(locale == "en" && totalGuest > 1){
		$(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guests'));
	}else{
		$(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guest'));
	}
}

function parseCookieSearchValues() {
    if(($('input[type=hidden][name="overrideSearchForm"]')&&$('input[type=hidden][name="overrideSearchForm"]').val()))
        putCookieSearchValues();
	if($.cookie('hotelSearchValues') ){
		var now = new Date();
		var searchData = JSON.parse($.cookie("hotelSearchValues"));
		$('.hotelAutoComplete').data("autoCompleteResult", searchData.searchAutoCompleteId);
		
		if(!$('[name="urlHotelName"]').length ){
			$('<input>').attr({
			    type: 'hidden',
			    id: 'urlHotelName',
			    name: 'urlHotelName'
			}).appendTo(this.form);
		}
		
		$('[name="urlHotelName"]').val(searchData.searchUrl);
		if ($('[name="hotelName"]').val() == null){
			$('[name="hotelName"]').val(searchData.searchUrl);
		}
		$('[name="id"]').val(searchData.searchAutoCompleteId);
		if(searchData.fromDate !=null && searchData.fromDate.length > 0){
			var from = $.datepicker.parseDate("dd.mm.yy", searchData.fromDate);
			var formattedFromDate = searchData.fromDate;
			if(now.getTime() > from.getTime()){
				from = new Date();
				from.setDate(from.getDate() + 1);
				formattedFromDate = $.datepicker.formatDate("dd.mm.yy", from);
			}
			
			$(".hasDatePickerCheckIn", document).datepicker("setDate", from);
			$(".hasDatePickerCheckIn").val(formattedFromDate);
		}
		if(searchData.toDate != null && searchData.toDate.length > 0){
			var to = $.datepicker.parseDate("dd.mm.yy", searchData.toDate);
			var formattedToDate = searchData.toDate;
			if(now.getTime() > to.getTime()){
				to = new Date();
				to.setMonth(now.getMonth(), now.getDate() + 7)
				formattedToDate = $.datepicker.formatDate("dd.mm.yy", to);
			}
			$(".hasDatePickerCheckOut", document).datepicker("setDate", to);
			$(".hasDatePickerCheckOut").val(formattedToDate);
		}
	}
}

function putCookieSearchValues(){
	var date = new Date();
	date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); //24 hour
	hotelSearch.searchAutoCompleteId = $('[name="id"]').val();
	hotelSearch.fromDate = $('[name="checkInDate"]').val();
	hotelSearch.toDate = $('[name="checkOutDate"]').val();
	hotelSearch.searchUrl = $('[name="urlHotelName"]').val();
	$.cookie('hotelSearchValues',  JSON.stringify(hotelSearch), { expires : date,  path : '/' });
}

function checkForSearchHotel(form) {
	var formValid = $(form).valid();
	var id = $('[name="id"]', form).val();
	
	//in case autocomplete is not selected	
	var urlHotelName = $('[name="hotelName"]').val();
	if(!id){
		$('[name="urlHotelName"]').val(urlHotelName);
	}

	if(formValid) {
		var fromDate = $("[name=checkInDate]", form).val();
		var toDate = $("[name=checkOutDate]", form).val();
		
		fromDate = $.datepicker.parseDate("dd.mm.yy", fromDate);
		toDate = $.datepicker.parseDate("dd.mm.yy", toDate);

		var day = 24*60*60*1000;
		var duration = Math.round(Math.abs((fromDate - toDate)/(day)));
		
		if(duration > 30){
			$('#hotelNotFound').modal('show');
		}else{
			var spLocationName = $(".hotelAutoComplete").val();
			$("#spLocationName").prepend(spLocationName);
			$('#hotelLoading').modal('show');
			putCookieSearchValues();
			form.submit();
		}
	}
}